import createClient from '../../helpers/api-client';

const defaultMenuItems = [
    {
        title: 'Hitta hantverkare',
        to: '/skapa-forfragan/',
        children: null,
    },
    {
        title: 'Medlemsföretag',
        to: '/sok-hantverkare/',
        children: null,
    },
];

const defaultCompanyMenuItems = [
    {
        title: 'Sök förfrågan',
        to: '/sok-forfragan/',
        children: null,
    },
];

const storeSuffix = 'Meta';

// Actions
export const FETCH_META_DATA = `fetchMeta${storeSuffix}`;

//Mutations
export const BEGIN_FETCH_META_DATA = `beginFetchMetaMutation${storeSuffix}`;
export const RECEIVED_META_DATA = `receivedMetaMutation${storeSuffix}`;
export const META_DATA_NOT_FOUND = `metaNotFoundMutation${storeSuffix}`;

// Getters
export const GET_META_DATA = `getMetaDataGetter${storeSuffix}`;
export const GET_STRINGS = `getStringsGetter${storeSuffix}`;
export const GET_LINKS = `getLinksGetter${storeSuffix}`;
export const GET_HEADER_MENU = `getHeaderMenuGetter${storeSuffix}`;
export const GET_COMPANY_MENU = `getCompanyMenuGetter${storeSuffix}`;
export const GET_CONTACT_WIDGET = `getContactWidgetGetter${storeSuffix}`;
export const GET_CONTACT_MENU = `getContactMenuGetter${storeSuffix}`;
export const GET_FOOTER_MENU = `getFooterMenuGetter${storeSuffix}`;
export const GET_SOCIAL_MEDIA_LINKS = `getSocialMediaLinksGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const GET_404_LINKS = `get404LinksGetter${storeSuffix}`;
export const GET_404_Text = `get404TextGetter${storeSuffix}`;
export const GET_404_Image = `get404ImageGetter${storeSuffix}`;

export const modelState = () => ({
    meta: {
        isLoading: true,
        error: false,
        data: {
            acf: {},
            options: {},
            headerMenu: defaultMenuItems,
            headerMenuCompany: defaultCompanyMenuItems,
        },
    },
});

export const actions = {
    [FETCH_META_DATA]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH_META_DATA);

            try {
                const res = await apiClient.get(`/api/meta`);
                commit(RECEIVED_META_DATA, res);
                resolve(res);
            } catch (error) {
                console.log(error);
                commit(META_DATA_NOT_FOUND, {
                    error,
                });
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_FETCH_META_DATA]: state => {
        state.meta.isLoading = true;
        state.meta.error = false;
    },
    [RECEIVED_META_DATA]: (state, payload) => {
        const { data } = payload;
        state.meta.data = data;
        state.meta.data.headerMenu = [
            ...defaultMenuItems,
            ...state.meta.data.headerMenu,
        ];
        state.meta.data.headerMenuCompany = [
            ...defaultCompanyMenuItems,
            ...state.meta.data.headerMenuCompany,
        ];
        state.meta.isLoading = false;
        state.meta.error = false;
    },
    [META_DATA_NOT_FOUND]: (state, payload) => {
        state.meta.isLoading = false;
        state.meta.error = true;
    },
};

export const getters = {
    [GET_META_DATA]: state => {
        return state.meta.data;
    },
    [GET_STRINGS]: state => {
        return state.meta.data.options.strings;
    },
    [GET_LINKS]: state => {
        return state.meta.data.options.links;
    },
    [GET_HEADER_MENU]: state => {
        return state.meta.data.headerMenu;
    },
    [GET_COMPANY_MENU]: state => {
        return state.meta.data.headerMenuCompany;
    },
    [GET_CONTACT_WIDGET]: state => {
        return state.meta.data.options.contact_widget;
    },
    [GET_CONTACT_MENU]: state => {
        return state.meta.data.options.footer_contact_menu.footer_menu_blocks;
    },
    [GET_FOOTER_MENU]: state => {
        return state.meta.data.options.footer_other_menu.footer_menu_blocks;
    },
    [GET_SOCIAL_MEDIA_LINKS]: state => {
        return state.meta.data.options.footer_social_links;
    },
    [IS_LOADING]: state => {
        return state.meta.isLoading;
    },
    [GET_ERROR]: state => {
        return state.meta.error;
    },
    [GET_404_LINKS]: state => {
        return state.meta.data.options.links404;
    },
    [GET_404_Text]: state => {
        return state.meta.data.options.text404;
    },
    [GET_404_Image]: state => {
        return state.meta.data.options.image404.url;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/meta-model.js